import { type ComponentType } from 'react';
import { type SvgIconProps } from '@common/components/svgs/props';
import { getColorVariable, type IconColor } from '@common/types/colors';

export type IconComponentType = ComponentType<SvgIconProps>;

export interface IconProps {
  component: IconComponentType;
  size?: 16 | 24;
  color?: IconColor;
}

export const rotateIcon = (IconToRotate: ComponentType, angle: number) => {
  function RotatedIcon(props: Readonly<SvgIconProps>) {
    return <IconToRotate style={{ transform: `rotate(${angle}deg)` }} {...props} />;
  }
  RotatedIcon.displayName = `rotated${angle}-${IconToRotate.displayName}`;
  return RotatedIcon;
};

function Icon({
  component: IconWrapper,
  color,
  ...rest
}: Readonly<IconProps>) {
  return <IconWrapper {...rest} color={getColorVariable(color)} pointerEvents="none" />;
}

export default Icon;
